/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { VariantCategory } from './VariantCategory';
import {
    VariantCategoryFromJSON,
    VariantCategoryFromJSONTyped,
    VariantCategoryToJSON,
} from './VariantCategory';
import type { VariantOption } from './VariantOption';
import {
    VariantOptionFromJSON,
    VariantOptionFromJSONTyped,
    VariantOptionToJSON,
} from './VariantOption';
import type { VariantValueCategory } from './VariantValueCategory';
import {
    VariantValueCategoryFromJSON,
    VariantValueCategoryFromJSONTyped,
    VariantValueCategoryToJSON,
} from './VariantValueCategory';

/**
 * Representation of a Variant Matrix Element
 * @export
 * @interface VariantMatrixElement
 */
export interface VariantMatrixElement {
    /**
     * 
     * @type {VariantValueCategory}
     * @memberof VariantMatrixElement
     */
    variantValueCategory?: VariantValueCategory;
    /**
     * 
     * @type {VariantCategory}
     * @memberof VariantMatrixElement
     */
    parentVariantCategory?: VariantCategory;
    /**
     * 
     * @type {VariantOption}
     * @memberof VariantMatrixElement
     */
    variantOption?: VariantOption;
    /**
     * List of elements with the type of variant matrix element
     * @type {Array<VariantMatrixElement>}
     * @memberof VariantMatrixElement
     */
    elements?: Array<VariantMatrixElement>;
    /**
     * 
     * @type {boolean}
     * @memberof VariantMatrixElement
     */
    isLeaf?: boolean;
}

/**
 * Check if a given object implements the VariantMatrixElement interface.
 */
export function instanceOfVariantMatrixElement(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VariantMatrixElementFromJSON(json: any): VariantMatrixElement {
    return VariantMatrixElementFromJSONTyped(json, false);
}

export function VariantMatrixElementFromJSONTyped(json: any, ignoreDiscriminator: boolean): VariantMatrixElement {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'variantValueCategory': !exists(json, 'variantValueCategory') ? undefined : VariantValueCategoryFromJSON(json['variantValueCategory']),
        'parentVariantCategory': !exists(json, 'parentVariantCategory') ? undefined : VariantCategoryFromJSON(json['parentVariantCategory']),
        'variantOption': !exists(json, 'variantOption') ? undefined : VariantOptionFromJSON(json['variantOption']),
        'elements': !exists(json, 'elements') ? undefined : ((json['elements'] as Array<any>).map(VariantMatrixElementFromJSON)),
        'isLeaf': !exists(json, 'isLeaf') ? undefined : json['isLeaf'],
    };
}

export function VariantMatrixElementToJSON(value?: VariantMatrixElement | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'variantValueCategory': VariantValueCategoryToJSON(value.variantValueCategory),
        'parentVariantCategory': VariantCategoryToJSON(value.parentVariantCategory),
        'variantOption': VariantOptionToJSON(value.variantOption),
        'elements': value.elements === undefined ? undefined : ((value.elements as Array<any>).map(VariantMatrixElementToJSON)),
        'isLeaf': value.isLeaf,
    };
}

